(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminGeneralDisplaySettingsController', AdminGeneralDisplaySettingsController);

    function AdminGeneralDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        siteAssociateTypesCollection,
        $translate,
        recurrenceRulesService,
        contractManager,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'general_logo',
                'general_opening_time',
                'general_closing_time',
                'general_tasks_generate_ahead',
                'general_audits_generate_ahead',
                'general_actions_paperwork_note_required',
                'general_actionsiteassociatetype',
                'general_auditcompletionemailassociatetype',
                'general_helpdesk_number',
                'general_global_helpdesk_number',
                'general_helpdesk_email',
                'general_tenant_emailer_reply_email',
                'general_training_link',
                'general_default_locale',
                'general_non_priority_colour',
                'general_p2p_started_at_date',
                'general_contract_manager',
                'general_inactivate_users_enabled',
                'general_inactivate_users_days',
                'general_meridian_workflow',
                'general_meridian_compliance_documents_available'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);

        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');
        // Expose contractManager for template display
        vm.contractManager = contractManager;

        if (siteAssociateTypesCollection && siteAssociateTypesCollection.siteAssociateTypes) {
            const selectedAssociateType = lodash.find(siteAssociateTypesCollection.siteAssociateTypes, (element) => {
                return element.id === vm.settings.general_actionsiteassociatetype.value;
            });

            if (typeof selectedAssociateType !== 'undefined') {
                vm.settings.general_actionsiteassociatetype.value = selectedAssociateType.name;
            }
        }

        if (siteAssociateTypesCollection && siteAssociateTypesCollection.siteAssociateTypes) {
            siteAssociateTypesCollection.siteAssociateTypes.unshift({ name: $translate.instant('NONE_SELECTED'), id: null });

            const selectedAuditCompletionAssociateType = lodash.find(siteAssociateTypesCollection.siteAssociateTypes, (element) => {
                if (vm.settings['general_auditcompletionemailassociatetype'].value.length === 0) {
                    return element.id === null;
                }
                return element.id === vm.settings['general_auditcompletionemailassociatetype'].value;
            });

            if (typeof selectedAuditCompletionAssociateType !== 'undefined') {
                vm.settings['general_auditcompletionemailassociatetype'].value = selectedAuditCompletionAssociateType.name;
            }
        }
    }
})();
